import React from 'react';

export default function Button({ children, href, className = '' }) {
  return (
    <a 
      href={href} 
      className={`
        inline-block px-8 py-4 bg-blush text-white 
        uppercase tracking-widest rounded-full font-semibold text-sm 
        transition-all duration-300 hover:bg-[#d48da3] hover:shadow-lg 
        hover:-translate-y-0.5
        ${className}
      `}
    >
      {children}
    </a>
  );
}